// extracted by mini-css-extract-plugin
export default {"root":"sxuP0IK6DU5KvHVat_2A","fail":"Gwr1KVJkjjbonJJJK7mK","pass":"fXmfa7Nwvnr35zLDyAmF"};